import { useEffect, useState } from "react";

export function useDelayUnmount(dependancy, delay = 300) {
  const [show, setShow] = useState(() => !!dependancy);

  useEffect(() => {
    let timeout;
    if (!!dependancy === false) {
      timeout = setTimeout(() => {
        setShow(false);
      }, JSON.parse(delay));
    }
    if (!!dependancy === true) {
      setShow(true);
    }
    return () => clearTimeout(timeout);
  }, [dependancy, delay]);

  return show;
}
